// extracted by mini-css-extract-plugin
export default {"helpModalContainer":"ShipmentDetails_helpModalContainer__KOIGW"};